import { Injectable } from '@angular/core';
import { NatLanguage } from './nat-language';

export class MobileUser {
  UserID: number;
  DepotID: number;
  ChuteID: number;
  firstname: string;
  Name: string;
  UserName: string;
  Password: string;
  Email: string;
  language: NatLanguage;
  MobileModules: string;
  RouteIds: number[] = [];
  RouteId: number;
  SectorIds: number[] = [];
  AllSectorIds: number[] = [];
  AutoSendNCV: boolean;
  AdminTPSLRoute: boolean;
  FilterCompleted: number;
  authdata: string;
}

export enum eMobilModuleAccess {
  SCAN_CHUTE = 1,
  SCAN_INFO = 2,
  SCAN_PICKUP = 3,
  SCAN_AGENT = 4
}
